import React from 'react'

const BillBoard = () => {
  return (
    <>BillBoard</>
  )
}

export default BillBoard